
<div class="expansion-panel2">
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="w-100">
              <div
                class="w-100 mt-5 d-flex align-items-center justify-content-between"
              >
                <h4>Attachments</h4>
                <!-- <label
                  *ngIf="fundImages.length < 10"
                  class="cursor-pointer"
                  mat-raised-button
                >
                  <i class="ri-edit-line"></i>
                  <input hidden type="file" (change)="uploadFundImage($event)" />
                </label> -->
              </div>
              <hr />
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
  
        <div class="row first-panel">
          <div>            
            <br />
            <div class="row g-4" >
              <div class="col-3">
                <app-file-uploader 
                  [label]="'Click here to upload Files'"
                  (fileSelected)="onFileSelected($event.event)">
                </app-file-uploader>
              </div>
              <div class="col-3" *ngIf="requestAttachments.length > 0">
                <mat-form-field class="col-12 mb-3">
                    <input
                      id="id-number"
                      matInput
                      placeholder="File Name"
                      [(ngModel)]="fileName"
                      (input)="filter()"
                    />
                  </mat-form-field>
</div>    
              <div class="col-3" *ngIf="requestAttachments.length > 0">
                <mat-form-field class="col-12 mb-3">
                    <input
                      id="uploadDate"
                      matInput
                      [matDatepicker]="uploadDatePicker"                      
                      placeholder="upload Date"
                      readonly
                      [(ngModel)]="uploadDate"
                      (dateInput)="filter()"
                    />
                    <mat-datepicker-toggle matSuffix [for]="uploadDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker   #uploadDatePicker></mat-datepicker>
                  </mat-form-field>
</div>    
              <div class="col-3" *ngIf="requestAttachments.length > 0">
                <mat-form-field class="col-12 mb-3">
                    <input
                      id="uploadedBy"
                      matInput
                      placeholder="Uploaded By"
                      [(ngModel)]="uploadedBy"
                      (input)="filter()"
                    />
                  </mat-form-field>
</div>    
          
                  
          
            <div class="row col-12 g-3">
              <div class="col-3" *ngFor="let file of requestAttachmentsFiltered; let i = index">
                <div class="file-container">
                  <img
                    [src]="file.url"
                    alt="Preview"
                    onerror="this.src='../../../../../assets/image/Rectangle 2657 (1).png'"
                  />
                  <div class="actions">
                    <div>
                    <p class="file-name">{{ file.title }}</p>
                    <p class="lite-color">Uploaded By: {{ file.createBy }}</p>
                    <p class="lite-color">Uploaded Date: {{ file.createAt | date:'dd/MM/yyyy' }}</p>
                  </div>
                    <i
                      class="ri-delete-bin-line delete cursor-pointer"
                      (click)="delete(file.id!)"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>